/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react'
import { Helmet } from 'react-helmet'


/**
 * SEO component
 * @param title
 * @param description
 * @param lang
 * @param keywords
 * @param siteMeta
 * @returns {*}
 * @constructor
 */
function SEO({ title, description, lang, keywords, siteMeta }) {
  const { defaultTitle, defaultDescription } = siteMeta
  return (
    <Helmet htmlAttributes={{ lang: lang }} title={defaultTitle} titleTemplate={`%s - ${title}`}>
      <link
        href="https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap"
        rel="stylesheet"
      />
      <meta name="description" content={description ? description : defaultDescription} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  keywords: ['JavaScript', 'React', 'Node.js', 'HTML', 'CSS', 'Cloud']
}

export default SEO
